var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnAstrovault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37236 8.65336L1.49707 13.6708H4.0706L5.65147 10.8845L4.37236 8.65336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35464 8.67512L7.99703 9.30027L4.07053 2.37016H1.51682L8.01775 13.6872L9.62204 10.8863L8.35464 8.67512Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98186 2.35388L6.38748 5.13754L7.65578 7.3514L8.00258 6.74077L11.9615 13.6709H14.4828L7.98186 2.35388Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.63 7.38219L14.5026 2.37016H11.9624L10.3608 5.16833L11.63 7.38219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAstrovault);
export default __webpack_public_path__ + "static/media/icn-astrovault.6a596d79ae856757895fc927cd0c3ffb.svg";
export { ForwardRef as ReactComponent };